<template lang="pug">
  v-card.rounded-xl.elevation-3(style="overflow:hidden")
    v-card-text.pa-0(style="position:relative;")
      //-v-img(:src="imagen" height="100" contain)
      //-div(:src="imagen" :style="'height:80px;background-color:#003A7E;background-image:"+imagen+";background-position:-100px 0px !important'")
      div(:style="'height:'+62+'px;'")
        div(style="width:76px;height:62px;float:left;margin-right:15px;border-left:#D5A022 solid 6px !important;border-right:#DDD solid 1px !important;").white
          p(style="font-size:10px;text-align:center;line-height:22px;color:#960407;").font-weight-medium.pa-0.ma-0 {{ fecha.split("-")[1] }}
          p(style="font-size:24px;text-align:center;line-height:20px;color:#960407;").pa-0.ma-0.font-weight-bold {{ fecha.split("-")[0] }}
          p(style="font-size:13px;text-align:center;line-height:22px;color:#960407;").pa-0.ma-0 {{ fecha.split("-")[2] }}
        p.font-weight-thin(style="padding-top:22px;font-size:28px;text-transform:uppercase;").text-left {{ tipo }}
      v-btn(@click="descargarArchivo(archivo)" style="position:absolute;bottom:15px;right:13px;padding:8px 10px 8px 10px;height:auto;background: linear-gradient(0deg,#b07d01 0%, #dfa92b 80%)!important;" color="#D5A022" dark).txtn
        | Descargar&nbsp;
        v-icon(size="16") fas fa-download
    v-divider
    v-card-text
      div(style="width:auto;")
        //-div(style="width:62px;height:62px;float:left;margin-right:15px").orange.darken-2
          p(style="font-size:10px;text-align:center;line-height:22px;").font-weight-medium.pa-0.ma-0.white--text {{ fecha.split("-")[1] }}
          p(style="font-size:24px;text-align:center;line-height:20px;").pa-0.ma-0.white--text.font-weight-bold {{ fecha.split("-")[0] }}
          p(style="font-size:13px;text-align:center;line-height:22px;").pa-0.ma-0.white--text {{ fecha.split("-")[2] }}
        h6.subtitle-1(style="text-align:justify;line-height:22px;").mb-2.font-weight-medium
          //-v-chip(color="blue darken-2" small dark label style="margin-top:-5px;height:20px")
            | {{ tipo }}
          //-| &nbsp;{{ titulo }}
          | {{ titulo }}
      p(style="text-align:justify;" v-html="description").pt-0.mb-0.custom-content-desc
</template>

<style lang="stylus">
.custom-content-desc :link
  color #962427 !important
.custom-content-desc :visited
  color #E67477 !important
.custom-new-img
  background-size 200px !important
</style>

<script>
export default {
  data: () => ({
    rotator: 0
  }),
  props: {
    reverse: Boolean,
    imagen: String,
    titulo: String,
    fecha: String,
    description: String,
    tipo: String,
    archivo: String
  },
  methods:{
    descargarArchivo(url){
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = url.replace(/^.*[\\\/]/, '')
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    }
  }
}
</script>
